/**
 * GO/src/orderservice/orderservice.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OrderHistoryEntryorderStatus = 'eNone' | 'eCreated' | 'eUploadStarted' | 'eUploadFinished' | 'eImported' | 'eConfirmationMailSend' | 'eBatched' | 'eImageEnhanced' | 'ePrintProductsCreated' | 'eInProduction' | 'eProductionFinished' | 'eCheckout' | 'eInvoiceCreated' | 'eInvoiceMailSend' | 'eError';

export const OrderHistoryEntryorderStatus = {
    ENone: 'eNone' as OrderHistoryEntryorderStatus,
    ECreated: 'eCreated' as OrderHistoryEntryorderStatus,
    EUploadStarted: 'eUploadStarted' as OrderHistoryEntryorderStatus,
    EUploadFinished: 'eUploadFinished' as OrderHistoryEntryorderStatus,
    EImported: 'eImported' as OrderHistoryEntryorderStatus,
    EConfirmationMailSend: 'eConfirmationMailSend' as OrderHistoryEntryorderStatus,
    EBatched: 'eBatched' as OrderHistoryEntryorderStatus,
    EImageEnhanced: 'eImageEnhanced' as OrderHistoryEntryorderStatus,
    EPrintProductsCreated: 'ePrintProductsCreated' as OrderHistoryEntryorderStatus,
    EInProduction: 'eInProduction' as OrderHistoryEntryorderStatus,
    EProductionFinished: 'eProductionFinished' as OrderHistoryEntryorderStatus,
    ECheckout: 'eCheckout' as OrderHistoryEntryorderStatus,
    EInvoiceCreated: 'eInvoiceCreated' as OrderHistoryEntryorderStatus,
    EInvoiceMailSend: 'eInvoiceMailSend' as OrderHistoryEntryorderStatus,
    EError: 'eError' as OrderHistoryEntryorderStatus
};
